<template>
<div id="app" :class="{'footer-grey-bg': $route.name === 'WeightLossStyleThree'}">

    <template>
        <router-view :baseUrl="baseUrl" :stripeKey="StripeKey" :googleMapsApiKey="googleMapsApiKey" @add-to-cart="addItemToCart">
        </router-view>
        <ShoppingCart v-if="showGlobalCart" />
        <footer-section v-if="!isDashboardRoute && showFooter" />
        <HealthInfoConsentModal />
    </template>
</div>
</template>

<script>
import FooterElement from './components/common/footerElement.vue'
import ShoppingCart from './components/product/shoppingCart.vue'
import HealthInfoConsentModal from './components/common/HealthInfoConsentModal.vue'
import {
    fetchProductsFromServer
} from '@/utils/productData'
//import blurryLoader from './components/common/blurryLoader.vue'

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
const StripeKey = process.env.VUE_APP_STRIPE_KEY;
const GoogleMapsApiKey = process.env.VUE_APP_GOOGLE_KEY;
//const CACHE_DURATION = 24 * 60 * 60 * 1000;

export default {
    name: 'App',
    components: {
        'footer-section': FooterElement,
        ShoppingCart,
        HealthInfoConsentModal,

        //blurryLoader
    },
    data() {
        return {
            baseUrl: `${apiEndpoint}`,
            StripeKey: StripeKey,
            googleMapsApiKey: GoogleMapsApiKey,
            isLoading: false
        }
    },
    created() {
        this.initializeApp();

        setTimeout(() => {
            this.$store.dispatch('initTheme');

            // Identify existing user to widget on page load
            if (this.$store.getters.isAuthenticated && window.GuestChatWidget && typeof window.GuestChatWidget.identify === 'function') {
                const user = this.$store.getters.user;
                const token = this.$store.getters.authToken;
                if (user && token) {
                    window.GuestChatWidget.identify({
                        jwt: token,
                        userId: user.id,
                        userName: `${user.first_name} ${user.last_name}`,
                        userEmail: user.email
                    }).catch(err => console.error('Widget identify error on load:', err));
                }
            }
        }, 500);
    },
    computed: {
        isDashboardRoute() {
            return this.$route.path.startsWith('/home') ||
                   this.$route.path.startsWith('/product') ||
                   this.$route.path.startsWith('/store-product') ||
                   this.$route.path.startsWith('/get-started');
        },
        showGlobalCart() {
            const hiddenCartPaths = ['/login', '/forgot-password'];

            return !this.isDashboardRoute &&
                !hiddenCartPaths.includes(this.$route.path) &&
                !this.$route.path.startsWith('/password-reset/') &&
                !this.$route.path.startsWith('/signup/');
        },
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        isNotFormPage() {
            let rname = this.$route.name;
            return !['FormLoader'].includes(rname);
        },
        reportPage() {
            let rname = this.$route.name;
            return !['CareCalendar', 'Calendar'].includes(rname);
        },
        showFooter() {
            const hiddenRoutes = [
                'WeightLossStyleTwo',
                'WeightLossScrolling',
                'WeightLossCheckoutFlow',
                'WeightLossStyleThree',
                'weightLossCheckoutV2',
                'weightLossGoogleThreePlus',
                'checkoutCallCenter',
                'UpgradeCheckout',
                'medicalCheckin',
                'glpQuizFiveSteps',
                'upSellPage',
                'productPage',
                'longevityProduct'
            ];
            return !hiddenRoutes.includes(this.$route.name);
        }
    },
    methods: {
        addItemToCart(item) {
            this.$store.dispatch('addToCart', item);
        },
        async initializeApp() {
            try {
                await this.loadProducts();
            } catch (error) {
                console.error('Failed to initialize app:', error);
            }
        },
        async loadProducts() {
            try {
                await fetchProductsFromServer();
            } catch (error) {
                console.error('Error fetching/caching products:', error);
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    z-index: 9999;
}
</style>

<style>
/* Sticky footer layout */
#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

#app > div:first-child,
#app > section:first-child {
    flex: 1 0 auto;
}

#app > section:last-of-type {
    flex-shrink: 0;
}

/* Apply grey background to footer only on WeightLossStyleThree page */
#app.footer-grey-bg section .div-block-446 {
    background-color: #f9f9f9 !important;
    background-color: var(--f9-grey, #f9f9f9) !important;
}

#app.footer-grey-bg > section {
    background-color: #f9f9f9 !important;
    background-color: var(--f9-grey, #f9f9f9) !important;
}

/* The shared footer is a sibling of the page, so a page that follows the saved
   dark theme cannot reach it from its own scoped styles. The sibling selectors
   below only match when one of those pages is on screen. */
[data-theme="dark"] .upload-video-page ~ section .div-block-446,
[data-theme="dark"] .verify-address-page ~ section .div-block-446,
[data-theme="dark"] .upload-video-page ~ section #footerSection,
[data-theme="dark"] .verify-address-page ~ section #footerSection {
    background-color: #1f1f1f !important;
    background-color: var(--dash-color-gray-50, #1f1f1f) !important;
}

[data-theme="dark"] .upload-video-page ~ section .link-10,
[data-theme="dark"] .upload-video-page ~ section .paragraph-125,
[data-theme="dark"] .upload-video-page ~ section .text-block-855,
[data-theme="dark"] .upload-video-page ~ section .text-block-1479,
[data-theme="dark"] .verify-address-page ~ section .link-10,
[data-theme="dark"] .verify-address-page ~ section .paragraph-125,
[data-theme="dark"] .verify-address-page ~ section .text-block-855,
[data-theme="dark"] .verify-address-page ~ section .text-block-1479 {
    color: var(--dash-color-gray-700, #d4d4d4);
}

[data-theme="dark"] .upload-video-page ~ section .image-6,
[data-theme="dark"] .verify-address-page ~ section .image-6 {
    filter: brightness(0) invert(1);
}
</style>
